import { createSelector } from 'reselect'
import { getBrand } from 'react-redux/selectors/brand'
import { getUser } from 'react-redux/selectors/user'

export default createSelector(
  [ getBrand, getUser ],
  (brand, user) => {
    return {
      brand,
      user,
      error: !!user.error,
      errorText: user.error
    }
  }
)



// WEBPACK FOOTER //
// ./src/app/component/login/selector.js